export const handlePercentage = (value: string): string => {
  if (value.includes('%')) {
    return (parseFloat(value.replace('%', '')) / 100).toString();
  }
  return value;
};
